import { fireEvent, render, screen, waitFor } from '@testing-library/preact';
import { expect } from 'chai';
import { Toolbar } from '../Toolbar';
import { ToolbarSeparator } from '../ToolbarSeparator';
import { BaseButton } from '../../UNSAFE_BaseButton';
import { Button } from '../../UNSAFE_Button';
import { MenuButton } from '../../UNSAFE_MenuButton';
import { SplitMenuButton } from '../../UNSAFE_SplitMenuButton';
import userEvent from '@testing-library/user-event';

describe('Test Toolbar component', () => {
  const sampleToolbar = (
    <Toolbar>
      <BaseButton></BaseButton>
      <Button isDisabled={true}></Button>
      <ToolbarSeparator />
      <MenuButton></MenuButton>
      <SplitMenuButton></SplitMenuButton>
    </Toolbar>
  );

  it('Checks for Toolbar and amount of Toolbar content', async () => {
    render(sampleToolbar);
    const toolbar = screen.getAllByRole('toolbar')[0];
    const content = toolbar?.firstChild?.childNodes; // eslint-disable-line

    expect(toolbar).not.to.be.null;
    expect(content?.length).equals(5);
  });

  it('Uses left/right arrow keys to navigate, skipping disabled content and dividers', async () => {
    render(sampleToolbar);
    const toolbar = screen.getAllByRole('toolbar')[0];
    const content = toolbar?.firstChild?.childNodes; // eslint-disable-line
    const firstEnabledElement = content?.[0] as HTMLElement;
    const secondEnabledElement = content?.[3] as HTMLElement;

    await userEvent.tab();
    await waitFor(
      () => {
        expect(firstEnabledElement.matches(':focus')).to.be.true;
      },
      { timeout: 500 }
    );
    expect(firstEnabledElement.getAttribute('tabIndex')).equals('0');
    fireEvent.keyDown(firstEnabledElement, { key: 'ArrowRight', code: 'ArrowRight', charCode: 39 });
    await waitFor(
      () => {
        expect(secondEnabledElement.matches(':focus')).to.be.true;
      },
      { timeout: 500 }
    );
    expect(secondEnabledElement.getAttribute('tabIndex')).equals('0');
    expect(firstEnabledElement.getAttribute('tabIndex')).equals('-1');
    fireEvent.keyDown(secondEnabledElement, { key: 'ArrowLeft', code: 'ArrowLeft', charCode: 37 });
    await waitFor(
      () => {
        expect(firstEnabledElement.matches(':focus')).to.be.true;
      },
      { timeout: 500 }
    );
    expect(firstEnabledElement.getAttribute('tabIndex')).equals('0');
    expect(secondEnabledElement.getAttribute('tabIndex')).equals('-1');
  });
});
